<template>
  <div class="card">
    <div class="card-body">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="alert alert-info">
            You are about to finish the reservation process. Remember that you
            can make changes to your reservation, add more services, even add
            more members. In order to make these changes, you must contact us by
            writing to
            <a href="mailto:info@veronicaviewhotel.com"
              >info@veronicaviewhotel.com</a
            >
          </div>
          <div>
            <p>
              <b>Payment fee (5%) </b>+ <span>${{ $store.state.igv }}</span>
            </p>

              <h3 class="alert"><b>payment total:</b><span> <b>${{ $store.state.total }}:00</b></span></h3>
      
          </div>
          <div id="yourPAYPAL"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { loadScript } from "@paypal/paypal-js";
import { Modal } from 'ant-design-vue';
import { reactive, computed, ref, toRefs, onMounted,h } from "Vue";
import { useStore } from "Vuex";
import { message } from "ant-design-vue";
const key = "updatable";
export default {
  components: {
    // PayPalButton
  },
  props: {
    paypal: String,
    currency: String,
  },
  setup(props) {
    const prop = toRefs(props);
    const store = useStore();
    onMounted(() => {
      loadScript({
        "client-id": prop.paypal.value,
        currency: "USD",
      })
        .then((paypal) => {
          paypal
            .Buttons({
              createOrder: function (data, actions) {
                // This fnc sets up the details of the transaction, including the amount
                return actions.order.create({
                  purchase_units: [
                    {
                      description: "",
                      amount: {
                        currency_code: "USD",
                        value: store.getters.TotalPrice,
                      },
                    },
                  ],
                });
              },
              onApprove: function (data, actions) {
                message.loading({
                  content: "Loading...",
                  key,
                });
                const db = new FormData();
                db.append("db", JSON.stringify(store.state));
                fetch("/wp-content/themes/vvhotel/mail/SendRooms.php", {
                  method: "POST",
                  body: db,
                })
                  .then((response) => response.json())
                  .then((data) => {
                    if(data.success) {
                    countDown();
                    }else{
                      console.log(data)
                    }
                  });
                return actions.order.capture().then(function (orderData) {
             
                });
              },
              onError: function () {
                return (err) => {
                  console.error(err);
                  
                };
              },
            })
            .render("#yourPAYPAL")
            .catch((error) => {
              console.error("failed to render the PayPal Buttons", error);
            });
        })
        .catch((error) => {
          console.error("failed to load the PayPal JS SDK script", error);
        });
    });
     const countDown = () => {
      let secondsToGo = 20;
      const modal = Modal.success({
        title: 'Your reservation was made successfully',
         content: h('div', {}, [h('h3', 'Shortly we will send you the confirmation to the email'), h('p', `Redirecting in ${secondsToGo} second to home`)]),
        onOk() {
   clearInterval(interval);
        modal.destroy();
        window.location.href ='https://www.veronicaviewhotel.com/';
            },
      });

      const interval = setInterval(() => {
        secondsToGo -= 1;
        modal.update({
           content: h('div', {}, [h('h3', 'Shortly we will send you the confirmation to the email'), h('p', `Redirecting in ${secondsToGo} second to home`)]),
        });
      }, 1000);
      setTimeout(() => {
        clearInterval(interval);
        modal.destroy();
        window.location.href ='https://www.veronicaviewhotel.com/';
      }, secondsToGo * 1000);
    };
    return {
    };
  },
};
</script>